import logger from 'utils/logger-aws'
import { ActiveArtistList, ActiveMonthList, EventAPIResponse, Pagination } from '../types'
import { generateEventEngineBasePath } from 'utils'

export class EventService {
  async getEventsFromEventEngine(
    startDate: string,
    endDate: string,
    artistId?: string
  ): Promise<{
    events: EventAPIResponse[]
    activeMonthList: ActiveMonthList[]
    eventsPagination: Pagination | null
    activeArtistList: ActiveArtistList[]
  }> {
    if (!artistId) {
      logger.error(`[EventService] - artistId is missing`)
      return this.emptyResponse()
    }

    try {
      const requestUrl = this.buildUrl({
        startDate,
        endDate,
        artistId
      })

      const response = await fetch(requestUrl, {
        headers: {
          Authorization: `Bearer ${process.env.NEXT_PUBLIC_EVENT_ENGINE_AUTH_TOKEN}`
        }
      })

      if (!response.ok) {
        logger.error(`[EventService] - HTTP ${response.status}: ${response.statusText}`)
        return this.emptyResponse()
      }

      const result = await response.json()
      const { results, meta } = result ?? {}

      const events = results ? Object.values(results) : []

      return {
        events: events as EventAPIResponse[],
        activeMonthList: meta?.activeMonthList ?? [],
        eventsPagination: meta?.pagination ?? null,
        activeArtistList: meta?.artists ?? []
      }
    } catch (error) {
      logger.error(`[EventService] - Failed to fetch events: ${String(error)}`)
      return this.emptyResponse()
    }
  }

  /** ---------------------------------------
   *  Helpers
   * --------------------------------------*/

  private buildUrl(params: { startDate: string; endDate: string; artistId: string }): string {
    const base = generateEventEngineBasePath()
    const url = new URL(base)

    url.searchParams.set('artist_id', params.artistId)
    url.searchParams.set('start_date', params.startDate)
    url.searchParams.set('end_date', params.endDate)

    return url.toString()
  }

  private emptyResponse() {
    return {
      events: [],
      activeMonthList: [],
      eventsPagination: null,
      activeArtistList: []
    }
  }
}
